module.exports = __webpack_public_path__ + "img/case2_1.f103ffd2.png";